import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43a2cebf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "controls" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn__title" }, "Star", -1))
const _hoisted_3 = { class: "btn__count" }
const _hoisted_4 = { class: "btn" }
const _hoisted_5 = { class: "btn__icon fork" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn__title --bold" }, "Fork", -1))
const _hoisted_7 = { class: "btn__count --bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "btn",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('removeStar')))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["btn__icon star", [{ starred: $props.starred }]])
      }, [
        _createVNode(_component_Icon, { name: "Star" })
      ], 2),
      _hoisted_2
    ]),
    _createElementVNode("div", _hoisted_3, _toDisplayString($props.repoStats.stars), 1),
    _createElementVNode("button", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Icon, { name: "Fork" })
      ]),
      _hoisted_6
    ]),
    _createElementVNode("div", _hoisted_7, _toDisplayString($props.repoStats.forks), 1)
  ]))
}